/* RESPONSIBLE TEAM: team-proactive-support */
import ReportBase from 'embercom/routes/apps/app/reports/base/report';
import { inject as service } from '@ember/service';

export default ReportBase.extend({
  customReportsService: service(),

  beforeModel() {
    this.customReportsService.routeToOverviewPage();
  },
});
